import { type IIRevResultState, type IIRevResultStates, type IZipRecruiterStates } from '@/helpers/types';
import { getCoreQuery, type IGetQuery } from '@/store/actions/api-utils';
import { type IRrevDataReq } from '@/store/actions/query/irev';

import { queryApiSlice } from '../apiSlice';

export const IRevApiSlice = queryApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getIrevPollingUnitDataModel: builder.mutation<IIRevResultStates, IRrevDataReq>({
			query: (body) => ({
				url: '/PollingUnitResult/get-all-multi-paged',
				method: 'POST',
				body,
			}),
		}),
		getIrevWardDataModel: builder.mutation<IIRevResultStates, IRrevDataReq>({
			query: (body) => ({
				url: '/WardResult/get-all-multi-paged',
				method: 'POST',
				body,
			}),
		}),
		getIrevStateDataModel: builder.mutation<IIRevResultStates, IRrevDataReq>({
			query: (body) => ({
				url: '/StateResult/get-all-multi-paged',
				method: 'POST',
				body,
			}),
		}),
		getIrevLgaDataModel: builder.mutation<IIRevResultStates, IRrevDataReq>({
			query: (body) => ({
				url: '/LocalGovernmentResult/get-all-multi-paged',
				method: 'POST',
				body,
			}),
		}),
		getIrevPollingUnitById: builder.query<IIRevResultState, { id: string }>({
			query: ({ id }) => ({
				url: `/PollingUnitResult/get-by-id/${id}`,
			}),
		}),
		getIrevWardById: builder.query<IIRevResultState, { id: string }>({
			query: ({ id }) => ({
				url: `/WardResult/get-by-id/${id}`,
			}),
		}),
		getIrevLgaById: builder.query<IIRevResultState, { id: string }>({
			query: ({ id }) => ({
				url: `/LocalGovernmentResult/get-by-id/${id}`,
			}),
		}),
		getIrevStateById: builder.query<IIRevResultState, { id: string }>({
			query: ({ id }) => ({
				url: `/StateResult/get-by-id/${id}`,
			}),
		}),
		getIrevPollingUnitByRefId: builder.query<IIRevResultState, { refId: string }>({
			query: ({ refId }) => ({
				url: `/PollingUnitResult/get-by-referenceid/${refId}`,
			}),
		}),
		getIrevWardByRefId: builder.query<IIRevResultState, { refId: string }>({
			query: ({ refId }) => ({
				url: `/WardResult/get-by-referenceid/${refId}`,
			}),
		}),
		getIrevLgaByRefId: builder.query<IIRevResultState, { refId: string }>({
			query: ({ refId }) => ({
				url: `/LocalGovernmentResult/get-by-referenceid/${refId}`,
			}),
		}),
		getIrevStateByRefId: builder.query<IIRevResultState, { refId: string }>({
			query: ({ refId }) => ({
				url: `/StateResult/get-by-referenceid/${refId}`,
			}),
		}),
		getIrevDownloadRequest: builder.query<IZipRecruiterStates, IGetQuery>({
			query: ({ paged, query }) => ({
				url: `/ZipResultRequest${getCoreQuery(paged, ...(query || []))}`,
			}),
		}),
	}),
});

export const {
	useGetIrevPollingUnitDataModelMutation,
	useGetIrevLgaDataModelMutation,
	useGetIrevStateDataModelMutation,
	useGetIrevWardDataModelMutation,
	useLazyGetIrevPollingUnitByIdQuery,
	useLazyGetIrevWardByIdQuery,
	useLazyGetIrevLgaByIdQuery,
	useLazyGetIrevStateByIdQuery,
	useLazyGetIrevPollingUnitByRefIdQuery,
	useLazyGetIrevWardByRefIdQuery,
	useLazyGetIrevLgaByRefIdQuery,
	useLazyGetIrevStateByRefIdQuery,
	useGetIrevDownloadRequestQuery,
	useLazyGetIrevDownloadRequestQuery,
} = IRevApiSlice;
